export default {"src":"/_next/static/media/typescript-logo.0a18fe98.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};